import { render, staticRenderFns } from "./HtSidebarDialog.vue?vue&type=template&id=3583bafe&scoped=true&"
import script from "./HtSidebarDialog.vue?vue&type=script&lang=js&"
export * from "./HtSidebarDialog.vue?vue&type=script&lang=js&"
import style0 from "./HtSidebarDialog.vue?vue&type=style&index=0&id=3583bafe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3583bafe",
  null
  
)

export default component.exports